import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/Basics/MDBox";

const InputCode = ({ item, label, value, onChange, codes, path }) => {
	const isArray = item.isArray || false;

	return (
		<MDBox>
			<FormControl fullWidth>
				<InputLabel id="select-label">{label}</InputLabel>
				<Select
					labelId="select-label"
					id="select"
					label={label}
					value={isArray ? value || [] : value || ""}
					name={path}
					multiple={isArray}
					onChange={e => {
						onChange(e.target.value);
					}}
				>
					{codes.map((code, index) => {
						return (
							<MenuItem key={index} value={code.value}>
								{code.label}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</MDBox>
	);
};
export default InputCode;
